import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'

import { Model } from 'modules/core/lib/mobx-rest'

export interface ProjectionParams {
  id?: string | null
  report_id?: string | null
  path: string
  function?: string
  group?: string
  order?: string
  ui_group?: string
  has_deprecated_path?: boolean
}

class Projection extends Model<ProjectionParams> {
  static urlRoot() {
    return '/reports/projections'
  }

  serialize(): ProjectionParams {
    return omitBy(this.toJS(), isNil) as ProjectionParams
  }

  get path(): string {
    return this.attributes.path
  }

  get function(): string | undefined {
    return this.attributes.function
  }
}

export default Projection
